import { switches } from "./items/switches";
import { thermomagneticSwitches } from "./items/thermomagneticSwitches";
import { magneticSwitches } from "./items/magneticSwitches";
import { electromagneticSwitches } from "./items/electromagneticSwitches";
import { overloadRelays } from "./items/overloadRelays";
import { fuses } from "./items/fuse";

import { powerSwitches } from "./items/powerSwitches";
import { electronicRelays } from "./items/electronicRelays";
import { restaurateurs } from "./items/restaurateurs";
import { fusesMt } from "./items/fusesMt";
import { inductionMotors } from "./items/inductionMotors";
import { synchronousMotors } from "./items/synchronousMotor";
import { vfds } from "./items/vfds";
import { softStarters } from "./items/softStarters";
import { distributionBoards } from "./items/distributionBoard";
import { engineControlCenters } from "./items/engineControlCenters";
import { lightningContactChargingCenters } from "./items/lightningContactChargingCenters";
import { generators } from "./items/generators";
import { photovoltaicGenerators } from "./items/photovoltaicGenerators";
import { electricEnergySuppliers } from "./items/electricEnergySuppliers";
import { fixedCapacitorBanks} from "./items/fixedCapacitorBanks";
import { automaticCapacitorBanks } from "./items/automaticCapacitorBanks";
import { upses } from "./items/upses";
import { twoWindingTransformers } from "./items/twoWindingTransformers";
import { threeWindingTransformers } from "./items/threeWindingTransformers";
import { cables } from "./items/cables";
import { electroducts } from "./items/electroducts";
import { distributionLines } from "./items/distributionLines";
import { buses } from "./items/bus";
import { subdiagram } from "./items/subdiagram";
import { textBoxes } from "./items/textBoxes";

const Symbols = {
  buses: buses,
  switches: switches,
  thermomagneticSwitches: thermomagneticSwitches,
  magneticSwitches: magneticSwitches,
  electromagneticSwitches: electromagneticSwitches,
  overloadRelays:overloadRelays,
  fuses: fuses,
  powerSwitches: powerSwitches,
  electronicRelays: electronicRelays,
  restaurateurs: restaurateurs ,
  fusesMt: fusesMt,
  inductionMotors: inductionMotors,
  synchronousMotors: synchronousMotors,
  vfds: vfds,
  softStarters: softStarters,
  distributionBoards: distributionBoards,
  engineControlCenters: engineControlCenters,
  lightningContactChargingCenters: lightningContactChargingCenters,
  generators: generators,
  photovoltaicGenerators: photovoltaicGenerators,
  electricEnergySuppliers: electricEnergySuppliers,
  fixedCapacitorBanks: fixedCapacitorBanks,
  automaticCapacitorBanks: automaticCapacitorBanks,
  upses: upses,
  twoWindingTransformers: twoWindingTransformers,
  threeWindingTransformers: threeWindingTransformers,
  cables: cables,
  electroducts: electroducts,
  distributionLines: distributionLines,
  subdiagram: subdiagram,
  textBoxes: textBoxes,
}

export default Symbols;
